<template>
    <main-dialog 
        :title="$t('convertPdfToHtml')" 
        v-model="isVisible" 
        @ok="handleConvert"
        :ok-title="$t('convert')"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
    >
        <div class="pdf-convert-form">
            <b-form-group :label="$t('inputFile')" label-for="input-file">
                <b-form-input
                    id="input-file"
                    :value="file.name"
                    disabled
                    readonly
                />
            </b-form-group>

            <b-form-group :label="$t('outputFileName')" label-for="output-filename">
                <b-form-input
                    id="output-filename"
                    v-model="outputFileName"
                    :placeholder="$t('enterOutputFileName')"
                />
                <small class="form-text text-muted">{{ $t('outputFileNameHint') }}</small>
            </b-form-group>

            <b-form-group>
                <b-form-checkbox v-model="outputHtml">
                    {{ $t('downloadAsHtml') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('downloadAsHtmlHint') }}</small>
            </b-form-group>

            <b-form-group v-if="!outputHtml">
                <b-form-checkbox v-model="saveToLibrary">
                    {{ $t('saveToLibrary') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('saveToLibraryHint') }}</small>
            </b-form-group>

            <b-form-group 
                v-if="!outputHtml && saveToLibrary" 
                :label="$t('outputPath')" 
                label-for="output-path"
            >
                <b-form-input
                    id="output-path"
                    v-model="outputPath"
                    :placeholder="$t('enterOutputPath')"
                />
                <small class="form-text text-muted">{{ $t('outputPathHint') }}</small>
            </b-form-group>
        </div>
    </main-dialog>
</template>

<script>
export default {
    name: 'PdfToHtmlModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        file: {
            type: Object,
            required: true
        },
        currentPath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            outputFileName: '',
            outputHtml: false,
            saveToLibrary: true,
            outputPath: ''
        };
    },
    computed: {
        isVisible: {
            get() {
                return this.show;
            },
            set(value) {
                if (!value) {
                    this.$emit('close');
                }
            }
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeForm();
            }
        }
    },
    methods: {
        initializeForm() {
            // Set default output file name based on input file
            const baseName = this.file.name.replace(/\.pdf$/i, '');
            this.outputFileName = `${baseName}.html`;
            
            // Set default output path to current directory
            this.outputPath = this.currentPath;
            
            // Reset options
            this.outputHtml = false;
            this.saveToLibrary = true;
        },
        handleConvert(bvModalEvt) {
            bvModalEvt.preventDefault();
            
            // Validate
            if (!this.outputFileName) {
                this.$bvToast.toast(this.$t('pleaseEnterOutputFileName'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                return;
            }
            
            const options = {
                output_file_name: this.outputFileName,
                output_html: this.outputHtml
            };
            
            // Only include output_path if we're saving to library and not downloading as HTML
            if (!this.outputHtml && this.saveToLibrary) {
                options.output_path = this.outputPath;
            }
            
            this.$emit('convert', options);
            this.isVisible = false;
        }
    }
}
</script>

<style scoped>
.pdf-convert-form {
    padding: 10px 0;
}
</style>
